import type { SelectLine } from './SelectLine';

export class SelectLineGroup {
    public title: string;
    public lines: SelectLine[];
    public isActive: boolean = false;

    constructor(title: string, lines: SelectLine[], isActive: boolean = false) {
        this.title = title;
        this.lines = lines;
        this.isActive = isActive;
    }
}
